<div class="overlay_map">
    <div class="header_modal">
        <h1>Upload Link Mapa de Sobreposição</h1>
        <svg (click)="closeModal()" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none" style="margin-left: 8px;">
            <path d="M24.4046 8.90302C25.1985 8.10913 25.1985 6.82198 24.4046 6.02809L23.9719 5.59542C23.178 4.80153 21.8909 4.80153 21.097 5.59542L15 11.6924L8.90302 5.59542C8.10913 4.80153 6.82198 4.80153 6.02809 5.59542L5.59542 6.02809C4.80153 6.82198 4.80153 8.10913 5.59542 8.90302L11.6924 15L5.59542 21.097C4.80153 21.8909 4.80153 23.178 5.59542 23.9719L6.02809 24.4046C6.82198 25.1985 8.10913 25.1985 8.90302 24.4046L15 18.3076L21.097 24.4046C21.8909 25.1985 23.178 25.1985 23.9719 24.4046L24.4046 23.9719C25.1985 23.178 25.1985 21.8909 24.4046 21.097L18.3076 15L24.4046 8.90302Z" fill="white"/>
        </svg>
    </div>

    <div class="body_modal">
        <h2>Link do Mapa</h2>
        <input type="text" placeholder="Insira aqui o link">
    </div>

    <div class="buttons">
        <button class="button_cancel" (click)="closeModal()">
            <h1>Cancelar</h1>
        </button>
        <button class="button_save">
            <h1 style="font-weight: 700;font-family: 'Roboto';font-style: normal;">Salvar</h1>
        </button>
    </div>
</div>